<template>
  <div class="page-container">
    <div class="page-route-select">
      <router-link to="/cliente/monitores/cotacoes" class="page-route-select-text">
        Home
      </router-link>
      <span class="material-icons page-route-select-icon">play_arrow</span>
      <div class="page-route-select-text">Acompanhamento da Implantação</div>
    </div>
    <div style="display: flex; justify-content: space-between">
      <div class="page-title">{{ pageTitle }}</div>
    </div>
    <cc-loader-full v-show="is_loading" />
    <no-data-available
      v-if="total_items == 0 && !is_loading"
      :text="'Nenhum produto encontrado'"
    />
    <div v-show="!is_loading" class="attendance-page-table-container">
      <div v-show="!is_loading && total_items > 0" class="kanban-container">
        <div
          class="kanban-board"
          ref="kanbanBoard"
          @dragover="onKanbanDragOver"
          @dragenter.prevent
          @dragleave.prevent
        >
          <div
            v-for="status in kanbanColumns"
            :key="status.id"
            class="kanban-column"
            :data-status-id="status.id"
            :class="{ 'active-column': activeStatus(status.id) }"
          >
            <div class="kanban-column-header" :style="getHeaderColor(status.id)">
              <h3>{{ status.name }}</h3>
              <span class="badge"
                >{{ getStatusCount(status.id) }} - ({{
                  getColumnPercent(status.id)
                }}%)</span
              >
            </div>
            <draggable
              :list="getClientsByStatus(status.id)"
              group="clients"
              @end="onCardMoved"
              @drag="onCardDrag"
              class="kanban-cards-container"
              :move="checkMove"
              item-key="id"
              :disabled="false"
            >
              <div
                v-for="client in getClientsByStatus(status.id)"
                :key="client.id"
                class="kanban-card"
                :data-client-id="client.id"
              >
                <div class="kanban-card-header">
                  <!-- <AttendanceStatusCircle :status="client.attendance.status.id" /> -->
                  <strong
                    >{{
                      client.head_office
                        ? client.head_office.social_reazon
                        : client.group_name
                    }}
                  </strong>

                  {{ client.head_office ? client.head_office.state.fu : "N/A" }}
                </div>

                <div class="kanban-card-content">
                  <div style="display: flex; justify-content: space-between">
                    <div class="kanban-card-field">
                      <span class="label" style="margin-right: 4px">Status:</span>
                      <span :style="getStatusColor(getStatusNome(client))">{{
                        getStatusNome(client)
                      }}</span>
                    </div>
                    <div class="kanban-card-field">
                      <span class="label">Vendedores:</span>
                      {{
                        client.ult_cotacao && client.ult_cotacao.length > 0
                          ? client.ult_cotacao[0].Total_Concorrente != null
                            ? client.ult_cotacao[0].Total_Concorrente
                            : 0
                          : 0
                      }}
                      /
                      {{
                        client.ult_cotacao && client.ult_cotacao.length > 0
                          ? client.ult_cotacao[0].vend_digitado != null
                            ? client.ult_cotacao[0].vend_digitado
                            : 0
                          : 0
                      }}
                    </div>
                  </div>
                  <!-- <div class="kanban-card-field">
                    <span class="label">Estado:</span>
                    {{ client.head_office ? client.head_office.state.fu : "N/A" }}
                  </div> -->
                  <div style="display: flex; justify-content: space-between">
                    <div class="kanban-card-field">
                      <span class="label">Valor pedidos:</span>
                      R$
                      {{
                        client.ult_cotacao && client.ult_cotacao.length > 0
                          ? client.ult_cotacao[0].Total_Compra
                            ? client.ult_cotacao[0].Total_Compra || formatCurrency
                            : "N/A"
                          : "N/A"
                      }}
                    </div>

                    <div class="kanban-card-field">
                      <span class="label">Produtos:</span>
                      {{
                        client.ult_cotacao && client.ult_cotacao.length > 0
                          ? client.ult_cotacao[0].Total_Produto != null
                            ? client.ult_cotacao[0].Total_Produto
                            : 0
                          : 0
                      }}
                      /
                      {{
                        client.ult_cotacao && client.ult_cotacao.length > 0
                          ? client.ult_cotacao[0].prod_digitado != null
                            ? client.ult_cotacao[0].prod_digitado
                            : 0
                          : 0
                      }}
                      /
                      {{
                        client.ult_cotacao && client.ult_cotacao.length > 0
                          ? client.ult_cotacao[0].Prod_Comprados != null
                            ? client.ult_cotacao[0].Prod_Comprados
                            : 0
                          : 0
                      }}
                    </div>
                  </div>
                  <div
                    v-if="client.ult_cotacao && client.ult_cotacao.length > 0"
                    style="display: flex; justify-content: space-between"
                  >
                    <div class="kanban-card-field">
                      <span class="label">Data cotação:</span>
                      {{ client.ult_cotacao[0].Dt_Final | formatDateTime }}
                    </div>
                    <div class="kanban-card-field">
                      <span class="label">Nº cotação:</span>
                      {{ client.ult_cotacao[0].last_request_id }}
                    </div>
                  </div>
                  <div class="kanban-card-actions-full" style="position: relative">
                    <router-link
                      :to="{
                        name: 'monitors-page',
                        params: { tab: 'cotacoes' },
                        query: { client_id: client.id },
                      }"
                      :target="'_blank'"
                      class="kanban-action-btn"
                      title="Monitorar"
                    >
                      <span class="material-icons-outlined">desktop_windows</span>
                    </router-link>

                    <span
                      @click="showMoreModal = client"
                      class="material-icons-outlined"
                      title="Mais ações"
                      >settings</span
                    >

                    <span
                      @click="openEditAttachedFilesModal(client)"
                      title="Arquivos anexados"
                      class="kanban-action-btn"
                      style="color: #c27b57"
                    >
                      <span class="material-icons-outlined">attach_file</span>
                    </span>

                    <span
                      @click="edit(client)"
                      v-if="can('CLIENT', 'UPDATE')"
                      title="Editar"
                      class="kanban-action-btn"
                    >
                      <span class="material-icons-outlined answers-icon">edit</span>
                    </span>

                    <span
                      class="material-icons-outlined kanban-action-btn"
                      title="Informações"
                      @click="phoneClick(client.phone)"
                      @mouseover="show_info(client, true)"
                      @mouseout="show_info(client, false)"
                      style="color: #607d8b"
                      >info</span
                    >
                    <cc-popover
                      :visible="client.show_info || false"
                      :lefty="true"
                      class="cc-popover"
                    >
                      <div>
                        <p>
                          <strong class="pop-over-strong">Id:</strong> #{{ client.id }}
                        </p>
                        <p>
                          <strong class="pop-over-strong">CNPJ:</strong>
                          {{ client.cnpj || "" | VMask("## ### ###/####-##") }}
                        </p>
                        <p>
                          <strong class="pop-over-strong">Data cadastro:</strong>
                          {{ client.created_at | formatDateOnly }}
                        </p>
                        <p>
                          <strong class="pop-over-strong">Contato:</strong>
                          <cc-whatsapp
                            style="padding: 0 !important"
                            :phone="client.phone"
                          />
                        </p>
                      </div>
                    </cc-popover>
                  </div>
                </div>
              </div>
            </draggable>
          </div>
        </div>
      </div>
      <div class="total-requests-container">
        Total de Requisições: {{ totalRequests }} registros
      </div>
    </div>
    <MoreActionsModal
      v-if="showMoreModal"
      :client="showMoreModal"
      :closeDialog="() => (showMoreModal = false)"
      :updatePage="list"
    />
    <EditAttachedFilesModal
      v-if="showEditAttachedFilesModal"
      @close="closeEditAttachedFilesModal"
      :clientInfo="clientInfo"
    />
    <cc-new-client-modal
      :id="current_client ? current_client.id : null"
      :closeDialog="closeEditClientModal"
      v-if="showEditClientModal"
    />
    <user-management-modal
      :client="showUserManagementModal"
      v-if="showUserManagementModal"
      :closeDialog="() => (showUserManagementModal = false)"
    />
  </div>
</template>
<script>
import Paginacao from "@/components/cliente/base-components/Pagination";
import AttendanceStatus from "@/components/shared/AttendanceStatus";
import CommentList from "@/components/lists/comments/comment-list.component";
import MoreActionsModal from "@/components/lists/MoreActionsModal";
import StorageService from "@/services/TokenService";
import ErrorHandlerService from "@/services/ErrorHandlerService";
import { loaderMixin } from "@/mixins/sweet-loader.mixin";
import UserService from "@/services/v1/user.service";
import UserService3 from "@/services/v3/management/user.service";
import ClientService from "@/services/v3/client.service";
import ResaleService from "@/services/v3//resales/resale.service";
import InvitationsModal from "@/modals/client/invitations/invitations.modal";
import { perm_mixin } from "@/mixins/permission.mixin";
import Button from "@/components/ui/buttons/StandardButton.vue";
import StandardInput from "@/components/ui/inputs/StandardInput.vue";
import EditAttachedFilesModal from "@/modals/edit-attached-files/EditAttachedFiles.modal";
import NewClientModal from "@/modals/client/new/new-client.modal";
import AttendanceStatusCircle from "@/components/shared/AttendanceStatusCircle";
import ExcelDownload from "@/services/ExcelDownload.js";
import MobileClientRow from "./MobileClientRow.vue";
import * as CONSTANTS from "@/constants/constants";
import UserManagementModal from "@/modals/client/users/management.modal";
import ReportCard from "../../components/partials/ReportCard.vue";
import moment from "moment";
import draggable from "vuedraggable";

export default {
  mixins: [loaderMixin, perm_mixin],
  components: {
    /* ccPaginacao:  */ Paginacao,
    AttendanceStatus,
    "cc-new-client-modal": NewClientModal,
    CommentList,
    InvitationsModal,
    Button,
    StandardInput,
    EditAttachedFilesModal,
    AttendanceStatusCircle,
    MobileClientRow,
    MoreActionsModal,
    "user-management-modal": UserManagementModal,
    ReportCard,
    draggable,
  },
  data() {
    const isCriticalRoute = this.$route.path.includes("criticos");
    return {
      showCommentModal: false,
      showInvitationsModal: false,
      showEditAttachedFilesModal: false,
      revenda_id: null,
      arraySelectAttendant: [],
      arraySelectResale: [],
      isResaleAdminLoggedIn: undefined,
      showUserManagementModal: undefined,
      arraySelectState: [],
      arraySelectSegment: [],
      selectedSegment: undefined,
      selectedState: undefined,
      showMoreModal: false,
      is_loading: false,
      prefinished: undefined,
      suspended: undefined,
      implanted: undefined,
      total_items: 1,
      name_filter: "",
      current_client: null,
      show_comments: false,
      asdasd: { id: "prefinished ", name: "Pre-Finalizado" },
      current_client: null,
      show_invitations: false,
      provider_filter: null,
      is_client_modal_open: false,
      showEditClientModal: false,
      filterByProviders: [],
      items_by_page_value: 10000,
      user_svc: new UserService(),
      user_svc3: new UserService3(),
      svc: new ClientService(),
      resale_svc: new ResaleService(),
      storage_svc: new StorageService(),
      invitations: [],
      clients: [],
      current_provider: null,
      manage_groups: false,
      resale_id: null,
      on_watchStatusRequests: 0,
      startedStatusRequests: 0,
      waiting_requestStatusRequests: 0,
      no_contactStatusRequests: 0,
      suspendedStatusRequests: 0,
      noAttendance: 0,
      waiting_clientStatusRequests: 0,
      on_alertStatusRequests: 0,
      totalRequests: 0,
      clientInfo: undefined,
      attendenceTotal: 0,
      attendenceList: [],
      resaleTotal: 0,
      resaleList: [],
      stateTotal: 0,
      stateList: [],
      segmentTotal: 0,
      segmentList: [],
      scrollInterval: null,
      isDragging: false,
      dragStartX: 0,
      dragStartScrollLeft: 0,
      isCriticalRoute: isCriticalRoute,
      statuses: isCriticalRoute
        ? [
            { id: "WAITING_CLIENT", name: "Aguardando Cliente" },
            { id: "ON_ALERT", name: "Em alerta" },
          ]
        : [
            { id: "NO_CONTACT", name: "Sem Contato" },
            { id: "STARTED", name: "Iniciado" },
            { id: "WAITING_REQUEST", name: "Aguardando cotação" },
            { id: "ON_WATCH", name: "Em acompanhamento" },
          ],
      filters: {
        client: null,
        status: isCriticalRoute
          ? [
              { id: "WAITING_CLIENT", name: "Aguardando Cliente" },
              { id: "ON_ALERT", name: "Em alerta" },
            ]
          : [
              { id: "NO_CONTACT", name: "Sem Contato" },
              { id: "STARTED", name: "Iniciado" },
              { id: "WAITING_REQUEST", name: "Aguardando cotação" },
              { id: "ON_WATCH", name: "Em acompanhamento" },
            ],
      },

      breadcrumbs: isCriticalRoute
        ? [
            { name: "Clientes", route: "clients" },
            { name: "Acompanhamento Critico", route: "clients-attendances-critical" },
          ]
        : [
            { name: "Clientes", route: "clients" },
            { name: "Acompanhamento", route: "clients-attendances-implantation" },
          ],
      kanbanColumns: isCriticalRoute
        ? [
            { id: "WAITING_CLIENT", name: "Aguardando Cliente" },
            { id: "ON_ALERT", name: "Em alerta" },
          ]
        : [
            { id: "NO_CONTACT", name: "Sem contatos" },
            { id: "STARTED", name: "Iniciado" },
            { id: "WAITING_REQUEST", name: "Aguardando cotação" },
            { id: "ON_WATCH", name: "Em acompanhamento" },
          ],
    };
  },
  watch: {
    async "$route.path"(newPath) {
      const wasCritical = this.isCriticalRoute;
      this.isCriticalRoute = newPath.includes("criticos");

      if (wasCritical !== this.isCriticalRoute) {
        this.is_loading = true;
        this.initializeRouteSpecificData();

        await this.list();
        this.breadcrumbs = this.isCriticalRoute
          ? [
              { name: "Clientes", route: "clients" },
              { name: "Acompanhamento Crítico", route: "clients-attendances-critical" },
            ]
          : [
              { name: "Clientes", route: "clients" },
              { name: "Acompanhamento", route: "clients-attendances-implantation" },
            ];

        this.$store.dispatch("set_breadcrumbs", this.breadcrumbs);
        this.is_loading = false;
      }
    },
  },
  filters: {
    formatDateTime(value) {
      if (!value) return "N/A";
      return moment(value).format("DD/MM/YYYY HH:mm");
    },
    formatCurrency(value) {
      if (!value) return "R$ 0,00";
      const numericValue = parseFloat(value);
      if (isNaN(numericValue)) return "R$ 0,00";
      return `R$ ${numericValue.toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`;
    },
  },
  computed: {
    getStartedStatus() {
      return this.filters.status.find((s) => s.id == "STARTED");
    },
    getNoContactStatus() {
      return this.filters.status.find((s) => s.id == "NO_CONTACT");
    },
    pageTitle() {
      return this.isCriticalRoute
        ? "Painel de Implantação Crítico"
        : "Painel de Implantação";
    },
  },
  methods: {
    applyCriticalFilters(clients) {
      return clients.filter((client) =>
        this.filters.status.some((status) => client.attendance?.status?.id === status.id)
      );
    },

    applyImplantationFilters(clients) {
      return clients.filter((client) =>
        this.filters.status.some((status) => client.attendance?.status?.id === status.id)
      );
    },

    initializeRouteSpecificData() {
      if (this.isCriticalRoute) {
        this.filters.status = [
          { id: "WAITING_CLIENT", name: "Aguardando Cliente" },
          { id: "ON_ALERT", name: "Em alerta" },
        ];
        this.kanbanColumns = [
          { id: "WAITING_CLIENT", name: "Aguardando Cliente" },
          { id: "ON_ALERT", name: "Em alerta" },
        ];
        this.statuses = [
          { id: "WAITING_CLIENT", name: "Aguardando Cliente" },
          { id: "ON_ALERT", name: "Em alerta" },
        ];
      } else {
        this.filters.status = [
          { id: "NO_CONTACT", name: "Sem Contato" },
          { id: "STARTED", name: "Iniciado" },
          { id: "WAITING_REQUEST", name: "Aguardando cotação" },
          { id: "ON_WATCH", name: "Em acompanhamento" },
        ];
        this.kanbanColumns = [
          { id: "NO_CONTACT", name: "Sem contatos" },
          { id: "STARTED", name: "Iniciado" },
          { id: "WAITING_REQUEST", name: "Aguardando cotação" },
          { id: "ON_WATCH", name: "Em acompanhamento" },
        ];
        this.statuses = [
          { id: "NO_CONTACT", name: "Sem Contato" },
          { id: "STARTED", name: "Iniciado" },
          { id: "WAITING_REQUEST", name: "Aguardando cotação" },
          { id: "ON_WATCH", name: "Em acompanhamento" },
        ];
      }
    },
    getColumnPercent(statusId) {
      if (this.totalRequests === 0) return "0.00";

      const count = this.getStatusCount(statusId);
      return ((count / this.totalRequests) * 100).toFixed(2);
    },
    getUltimaCotacao(client) {
      return client.ult_cotacao && client.ult_cotacao.length > 0
        ? client.ult_cotacao[0]
        : null;
    },
    closeEditClientModal: function () {
      this.showEditClientModal = false;
    },
    edit(client) {
      this.current_client = client;
      this.showEditClientModal = true;
    },
    filterStatus() {
      this.updatePage();
    },
    show_info(item, show) {
      this.$set(item, "show_info", show);
    },
    manage_users(client) {
      this.showUserManagementModal = client;
    },
    toggleExpanded(client) {
      client.isExpanded = !client.isExpanded;
      this.$forceUpdate();
    },
    activeStatus(text) {
      if (!this.filters.status) return false;
      return this.filters.status.find((s) => s.id == text);
    },
    getActivefilter(text) {
      if (this.activeStatus(text)) return "border-width: 1px;";
    },
    toggleFilter(text) {
      if (this.filters.status.find((s) => s.id == text))
        this.filters.status = this.filters.status.filter((s) => s.id != text);
      else this.filters.status.push({ id: text });
      this.$forceUpdate();
    },
    getPercent(value) {
      if (!value || this.total_items < 1) return 0;
      return ((value / this.total_items) * 100).toFixed(2);
    },
    getStatusColor(status) {
      if (!status) return "";
      if (status == "PEDIDO GERADO") return "color: #7683F6; font-weight: 700;";
      else if (status == "CONGELADA" || status == "ABERTA")
        return "color: gray; font-weight: 700;";
      else if (status == "GERADA") return "color: #30AA4C; font-weight: 700;";
      else if (status == "NAO DIGITADA") return "color: #CD2A2A; font-weight: 700;";
      else if (status == "CANCELADA") return "color: #CD2A2A; font-weight: 700;";
      return "";
    },
    openEditAttachedFilesModal(client) {
      this.clientInfo = client;
      this.showEditAttachedFilesModal = true;
    },
    updateAttendance(client) {
      this.update_attendance(
        client,
        {
          ...client.attendance,
          status: { id: client.attendance.status.id },
        },
        client.attendance
      );
    },
    getResaleId() {
      this.revenda_id = this.storage_svc.get("revenda");
      if (this.revenda_id == 1) {
        this.isResaleAdminLoggedIn = true;
      } else {
        this.isResaleAdminLoggedIn = false;
        this.filters.resale = { id: this.revenda_id };
      }
    },
    closeInvitationsModal: function () {
      this.showInvitationsModal = false;
    },
    closeCommentModal: function () {
      this.showCommentModal = false;
    },
    closeEditAttachedFilesModal: function () {
      this.showEditAttachedFilesModal = false;
    },
    getSpecialBackground(idx) {
      if (idx % 2 != 0) return "page-table-line-special";
    },
    setGroupValue(value) {
      this.filters.name = value;
      this.page = 1;
      this.updatePage();
    },
    setAttendantValue(value) {
      this.filters.attendant = value;
      this.page = 1;
      this.updatePage();
    },
    setResaleCard(value) {
      this.setResaleValue({ id: value.id, name: value.text });
    },
    setResaleValue(value) {
      if (!this.isResaleAdminLoggedIn) return;
      this.filters.resale = value;
      this.page = 1;
      this.updatePage();
    },
    setStatusValue(value) {
      this.filters.status = value;
    },
    open_invitations(client) {
      this.current_client = client;
      this.showInvitationsModal = true;
    },
    edit_status(attendance) {
      attendance.is_editing = !attendance.is_editing;
      this.$forceUpdate();
    },
    load_resales() {
      return this.resale_svc.list().then((response) => {
        this.arraySelectResale.push({ text: "todos", value: undefined });
        response.data.data.forEach((element) => {
          if (this.filters.resale && this.filters.resale.id == element.id)
            this.filters.resale = element;
          this.arraySelectResale.push({
            text: element.name,
            value: element,
          });
        });
      });
    },
    update_attendance(client, attendance, obj_ref) {
      this.svc
        .update_attendance(client, {
          id: attendance.id,
          status: attendance.status.id,
          attendant_id: attendance.attendant.id,
        })
        .then((response) => response.data)
        .then((data) => {
          attendance.saved = true;
          obj_ref.is_editing = false;
          const notification = {
            type: "success",
            message: "Dados salvos com sucesso!",
          };
          this.$store.dispatch("notification/add", notification);
          this.$forceUpdate();
        });
    },
    renotify() {
      this.confirm_action({
        subtitle: `#${this.filters.client.name.toUpperCase()}`,
        message: "Confirma reenvio de notificações dos convites pendentes?",
        callback: () => {
          this.present_loader("Reenviando notificações...");
          this.svc.notify_all(this.filters.client).then(() => {
            this.present_info("Notificações Enviadas!");
          });
        },
      });
    },
    load_region_data() {
      return this.user_svc
        .region_data()
        .then((response) => response.data)
        .then((data) => {
          this.arraySelectState = data.estados.map((element) => {
            return {
              text: element.est_nome,
              value: element,
            };
          });
          this.arraySelectState.unshift({ text: "todos", value: undefined });
        });
    },
    getColor(i) {
      const colorList = [
        "#FF0000",
        "#00FF00",
        "#0000FF",
        "#FFFF00",
        "#FF00FF",
        "#00FFFF",
        "#800000",
        "#008000",
        "#000080",
        "#FFC0CB",
        "#800080",
        "#FFD700",
        "#008080",
        "#A52A2A",
        "#FFFFF0",
        "#F0E68C",
        "#F08080",
        "#FAEBD7",
        "#D2691E",
        "#FF7F50",
        "#FFFACD",
        "#7FFF00",
        "#BA55D3",
        "#DAA520",
        "#C71585",
        "#FF8C00",
        "#FF69B4",
      ];
      while (i > 26) i = i - 27;
      return colorList[i];
    },
    getListNew() {
      const status = this.filters.status ? this.filters.status.map((s) => s.id) : [];
      let params = {
        cli_id_revenda: this.filters.resale ? this.filters.resale.id : null,
        ramo_id: this.selectedSegment && this.selectedSegment.ramo_id,
        est_id: this.selectedState && this.selectedState.id,
        attendant_id: this.filters.attendant && this.filters.attendant.id,
        toDate: this.toDate ? this.toDate.split("T")[0] : null,
        fromDate: this.fromDate ? this.fromDate.split("T")[0] : null,
        toFinalDate: this.toFinalDate ? this.toFinalDate.split("T")[0] : null,
        dateNoCot: this.noCotDate ? this.noCotDate.split("T")[0] : null,
        fromFinalDate: this.fromFinalDate ? this.fromFinalDate.split("T")[0] : null,
        toSuspDate: this.toSuspDate ? this.toSuspDate.split("T")[0] + " 23:59:59" : null,
        fromSuspDate: this.fromSuspDate
          ? this.fromSuspDate.split("T")[0] + " 00:00:01"
          : null,
      };
      this.svc.listNew(params, status).then((resp) => {
        this.attendenceTotal = resp.data.summary.clients;
        this.attendenceList = resp.data.datail.clients
          .map((v, i) => {
            return {
              id: v.attendant_id,
              text: v.usu_nome,
              color: this.getColor(i),
              value: v.total_count,
            };
          })
          .sort((a, b) => b.value - a.value);
        this.resaleTotal = resp.data.summary.total_revenda;
        this.resaleList = resp.data.datail.total_revenda
          .map((v, i) => {
            return {
              id: v.cli_id_revenda,
              text: v.nome,
              color: this.getColor(i),
              value: v.total_count,
            };
          })
          .sort((a, b) => b.value - a.value);
        this.stateTotal = resp.data.summary.total_estado;
        this.stateList = resp.data.datail.total_estado
          .map((v, i) => {
            return {
              id: v.est_id,
              est_sigla: v.est_sigla,
              text: v.est_nome,
              color: this.getColor(i),
              value: v.total_count,
            };
          })
          .sort((a, b) => b.value - a.value);
        this.segmentTotal = resp.data.summary.total_ramo;
        this.segmentList = resp.data.datail.ramo
          .map((v, i) => {
            return {
              id: v.ramo_id,
              text: v.ramo_descricao,
              color: this.getColor(i),
              value: v.total_count,
            };
          })
          .sort((a, b) => b.value - a.value);
      });
    },
    getListTotals() {
      let params = {
        name: this.filters.name,
        attendant_id: this.filters.attendant ? this.filters.attendant.id : null,
        resale: this.filters.resale ? this.filters.resale.id : null,
        sort: "tbl_cliente.cli_id",
        count: 1,
        state: this.selectedState && this.selectedState.est_sigla,
        ramo: this.selectedSegment && this.selectedSegment.ramo_id,
        toDate: this.toDate?.split("T")[0],
        fromDate: this.fromDate?.split("T")[0],
        toFinalDate: this.toFinalDate?.split("T")[0],
        dateNoCot: this.noCotDate ? this.noCotDate.split("T")[0] : null,
        fromFinalDate: this.fromFinalDate?.split("T")[0],
        toSuspDate: this.toSuspDate ? this.toSuspDate.split("T")[0] + " 23:59:59" : null,
        fromSuspDate: this.fromSuspDate
          ? this.fromSuspDate.split("T")[0] + " 00:00:01"
          : null,
        noPagination: true,
      };

      this.svc
        .list(params)
        .then((response) => {
          let dataArray = [];

          if (response.data && Array.isArray(response.data)) {
            dataArray = response.data;
          } else if (
            response.data &&
            response.data.data &&
            Array.isArray(response.data.data)
          ) {
            dataArray = response.data.data;
          } else {
            console.error("Unexpected response structure:", response.data);
            return;
          }
          this.on_watchStatusRequests = 0;
          this.startedStatusRequests = 0;
          this.waiting_requestStatusRequests = 0;
          this.prefinished = 0;
          this.no_contactStatusRequests = 0;
          this.waiting_clientStatusRequest = 0;
          this.on_alertStatusRequests = 0;
          this.noAttendance = 0;

          dataArray.forEach((item) => {
            const status = item.status || item.attendance?.status?.id;
            const total = item.total || 0;

            if (status === "ON_WATCH") this.on_watchStatusRequests += total;
            else if (status === "STARTED") this.startedStatusRequests += total;
            else if (status === "WAITING_REQUEST")
              this.waiting_requestStatusRequests += total;
            else if (status === "NO_CONTACT") this.no_contactStatusRequests += total;
            else if (status == "WAITING_CLIENT")
              this.waiting_clientStatusRequests += total;
            else if (status == "ON_ALERT") this.on_alertStatusRequests += total;
            else if (!status) this.noAttendance += total;
          });
          this.$forceUpdate();
        })
        .catch((error) => {
          this.is_loading = false;
          ErrorHandlerService.handle(error, this.$store);
        });
    },
    setStateValue(value) {
      this.selectedState = value;
      this.updatePage();
    },
    updatePage() {
      this.list();
      this.getListTotals(this.page);
      this.getListNew();
    },
    setSegmentValue(value) {
      this.selectedSegment = value;
      this.updatePage();
    },
    getClientsSegmentList() {
      const config = {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      };
      axios
        .get(`${CONSTANTS.API_V3_URL}/admin/clients/ramo_clientes`, config)
        .then((data) => {
          this.arraySelectSegment.push({ text: "todos", value: undefined });
          data.data.forEach((element) => {
            this.arraySelectSegment.push({
              text: element.ramo_descricao,
              value: element,
            });
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    phoneClick(phone) {
      let begin = 3;
      if (!phone) return null;
      if (phone.length == 10) begin = 2;
      window
        .open(
          `https://api.whatsapp.com/send?phone=${phone.substr(0, 2)}${phone.substr(
            begin,
            phone.length
          )}`,
          "_blank"
        )
        .focus();
    },
    load_managers() {
      return this.user_svc3.list().then((response) => {
        this.managers = response.data;
        response.data.forEach((element) => {
          if (this.isResaleAdminLoggedIn || this.revenda_id == element.id_revenda) {
            this.arraySelectAttendant.push({
              text: element.name,
              value: element,
            });
          }
        });
      });
    },
    list() {
      this.is_loading = true;
      let params = {
        noPagination: true,
        status: this.filters.status ? this.filters.status.map((s) => s.id) : [],
        name: this.filters.name,
        attendant_id: this.filters.attendant ? this.filters.attendant.id : null,
        resale: this.filters.resale ? this.filters.resale.id : null,
        sort: "tbl_cliente.cli_id",
        state: this.selectedState && this.selectedState.est_sigla,
        ramo: this.selectedSegment && this.selectedSegment.ramo_id,
      };

      this.clients = [];
      this.svc
        .list(params)
        .then((response) => {
          const responseData = response.data;
          const now = moment();

          let dataArray = [];
          let metaData = {};

          if (Array.isArray(responseData)) {
            dataArray = responseData;
            this.total_items = responseData.length;
          } else if (responseData && Array.isArray(responseData.data)) {
            dataArray = responseData.data;
            metaData = responseData.meta || {};
            this.total_items = metaData.total || responseData.data.length;
          } else {
            console.error("Unexpected response structure:", responseData);
            this.is_loading = false;
            return;
          }

          dataArray.forEach((element) => {
            if (element.attendance && element.attendance.status) {
              if (element.attendance.status.id == "WAITING_REQUEST") {
                element.attendance.status.name = "Aguardando cotação";
              }
              if (element.attendance.status.id == "NO_CONTACT") {
                element.attendance.status.name = "Sem Contato";
              }
            }

            if (element.ult_cotacao && element.ult_cotacao.length > 0) {
              const cotDate = moment(element.ult_cotacao[0].Dt_Final);
              if (now - cotDate > 1728000000) element.old = true;
            }
            this.clients.push(element);
          });

          this.totalRequests = this.total_items;
          this.is_loading = false;
        })
        .catch((error) => {
          this.is_loading = false;
          ErrorHandlerService.handle(error, this.$store);
        });
    },
    getHeaderColor(statusId) {
      if (this.isCriticalRoute) {
        const colors = {
          WAITING_CLIENT: "rgb(144, 135, 83);",
          ON_ALERT: "#de9153",
          SUSPENDED: "#cd2a2a;",
        };
        return `background-color: ${colors[statusId] || "#e68c50"};`;
      } else {
        const colors = {
          NO_CONTACT: "#7a8370",
          STARTED: "rgb(144, 135, 83);",
          WAITING_REQUEST: "#de9153;",
          ON_WATCH: "#3b8c88;",
        };
        return `background-color: ${colors[statusId] || "#e68c50"};`;
      }
    },
    getStatusNome(client) {
      if (
        client.ult_cotacao &&
        client.ult_cotacao.length > 0 &&
        client.ult_cotacao[0].Status_nome
      ) {
        return client.ult_cotacao[0].Status_nome;
      }
      if (client.attendance && client.attendance.status) {
        return client.attendance.status.name;
      }
      return "N/A";
    },
    getClientsByStatus(statusId) {
      if (!this.filters.status.some((s) => s.id === statusId)) {
        return [];
      }
      return this.clients.filter(
        (client) =>
          client.attendance &&
          client.attendance.status &&
          client.attendance.status.id === statusId
      );
    },

    getStatusCount(statusId) {
      return this.clients.filter(
        (client) =>
          client.attendance &&
          client.attendance.status &&
          client.attendance.status.id === statusId
      ).length;
    },

    onCardDrag(evt) {
      if (!evt.originalEvent) return;

      this.isDragging = true;
      const kanbanBoard = this.$refs.kanbanBoard;
      if (!kanbanBoard) return;

      const mouseX = evt.originalEvent.clientX;
      const boardRect = kanbanBoard.getBoundingClientRect();

      const leftTriggerArea = boardRect.left + 100;
      const rightTriggerArea = boardRect.right - 100;

      let scrollSpeed = 0;

      if (mouseX < leftTriggerArea) {
        scrollSpeed = -20 * ((leftTriggerArea - mouseX) / 100);
      } else if (mouseX > rightTriggerArea) {
        scrollSpeed = 20 * ((mouseX - rightTriggerArea) / 100);
      }

      if (this.scrollInterval) {
        clearInterval(this.scrollInterval);
        this.scrollInterval = null;
      }

      if (scrollSpeed !== 0) {
        this.scrollInterval = setInterval(() => {
          if (this.isDragging && kanbanBoard) {
            kanbanBoard.scrollLeft += scrollSpeed;
          }
        }, 16);
      }
    },

    startAutoScroll(direction) {
      if (this.scrollInterval) {
        clearInterval(this.scrollInterval);
      }

      const kanbanBoard = this.$refs.kanbanBoard;
      if (!kanbanBoard) return;

      const scrollSpeed = direction === "left" ? -20 : 20;

      this.scrollInterval = setInterval(() => {
        kanbanBoard.scrollLeft += scrollSpeed;
      }, 16);
    },

    stopAutoScroll() {
      if (this.scrollInterval) {
        clearInterval(this.scrollInterval);
        this.scrollInterval = null;
      }
    },

    onKanbanDragOver(evt) {
      evt.preventDefault();
      if (this.isDragging && this.scrollInterval) {
        const kanbanBoard = this.$refs.kanbanBoard;
        if (kanbanBoard) {
        }
      }
    },

    async onCardMoved(evt) {
      this.isDragging = false;
      this.stopAutoScroll();

      try {
        let client;

        if (evt.item._underlying_vm_) {
          client = evt.item._underlying_vm_;
        }

        if (!client && evt.item.dataset) {
          const clientId = evt.item.dataset.clientId;
          if (clientId) {
            client = this.clients.find((c) => c.id == clientId);
          }
        }

        if (!client) {
          console.error("Cliente não encontrado no evento", evt);
          this.list();
          return;
        }

        let newStatusId = null;

        const columnElement = evt.to.closest(".kanban-column");
        if (columnElement) {
          newStatusId = columnElement.getAttribute("data-status-id");
        }

        if (!newStatusId) {
          console.error("Status de destino não encontrado");
          this.list();
          return;
        }

        newStatusId = newStatusId.trim();

        const currentStatusId = client.attendance?.status?.id;
        if (currentStatusId === newStatusId) {
          return;
        }

        const newStatus = this.statuses.find((s) => s.id === newStatusId) ||
          this.kanbanColumns.find((col) => col.id === newStatusId) || {
            id: newStatusId,
            name: newStatusId,
          };

        this.present_loader("Atualizando status...");

        const payload = {
          id: client.attendance.id,
          status: newStatusId,
          attendant_id: client.attendance.attendant
            ? client.attendance.attendant.id
            : null,
        };

        await this.svc.update_attendance(client, payload);

        if (!client.attendance) {
          client.attendance = { status: newStatus, attendant: null };
        } else {
          client.attendance.status = newStatus;
        }

        this.dismiss_loader();

        this.$store.dispatch("notification/add", {
          type: "success",
          message: "Status atualizado com sucesso!",
        });

        this.getListTotals();
        this.$forceUpdate();
      } catch (error) {
        this.dismiss_loader();
        console.error("Erro ao mover card:", error);
        this.list();

        ErrorHandlerService.handle(error, this.$store);
      }
    },

    checkMove(evt) {
      return true;
    },

    findClientById(clientId) {
      return this.clients.find((client) => client.id == clientId);
    },
  },
  async created() {
    this.getResaleId();
    this.load_resales();
    this.load_region_data();
    this.getClientsSegmentList();
    this.load_managers();
    if (this.$route.query.id) {
      this.filters.resale = { id: this.$route.query.id };
      this.filters.status = this.statuses;
    }
    this.initializeRouteSpecificData();
    this.list();
    this.$store.dispatch("set_breadcrumbs", this.breadcrumbs);
    this.getListTotals();
    this.getListNew();
  },
  beforeUnmount() {
    window.removeEventListener("keydown", this.handleGlobalKeydown);
    this.stopAutoScroll();
  },
};
</script>

<style lang="scss" scoped>
@import "@/sass/commons/_tables";

.cc-popover {
  position: absolute;
  top: 100%;
  left: 80%;
  z-index: 1000;
  width: 40px;
}
.manage-status {
  display: flex;
  align-items: center;
  i.fa-edit {
    font-size: 1rem;
    color: $secondary-color;
    cursor: pointer;
    margin-right: 10px;
  }
}
.change-status {
  display: flex;
  align-items: center;
  width: 100%;
  .success-update {
    margin-left: 5px;
    visibility: hidden;
    color: $brand-success;
    &.visibile {
      visibility: "visible";
    }
  }
}

.canceled {
  i {
    color: $brand-danger;
  }
}
.waiting {
  i {
    color: $yellow2;
  }
}
.confirmed {
  i {
    color: $ternary-color;
  }
}

.zap {
  i {
    color: #4ac959;
  }
  width: fit-content;
  &:hover {
    background: #4ac959;
    color: white;
    border-radius: 5px;
    i {
      color: white;
    }
  }
}

.actions {
  justify-content: center;
  i {
    margin-left: 10px;
    font-size: 1.2rem;
    cursor: pointer;
    &.fa-trash {
      color: red;
    }
  }
}
.radio-group {
  display: flex;
  align-items: center;
  .form-check {
    margin-right: 20px;
    margin-right: 20px;
    align-items: center;
    display: flex;
    height: 2rem;
    .form-check-label {
      cursor: pointer;
      margin-bottom: 0;
      display: flex;
      height: 100%;
      align-items: center;
      margin-left: 9px;
      font-size: 16px;
      color: black;
    }
    input {
      cursor: pointer;
      width: 1.5rem;
      height: 1.5rem;
      margin-right: 5px;
      margin-top: 0px;
      margin-bottom: 3px;
    }
  }
}
.filters {
  padding: 1rem;
  border-radius: 5px;
}

.page-container {
  font-size: 1vw;
  margin-right: 4em;
}
.page-table-input-select {
  padding: 0.25vh 1vw;
  border-radius: 10px;
  color: #35495e;
  border: 1px solid #e5e5e5;
  &:focus {
    outline: none;
  }
  width: 90%;
}
.page-filters__right-title-wrapper {
  display: flex;
  align-items: center;
}
.products-page__datetime-title {
  font-size: 1.7em;
  font-weight: 400;
  letter-spacing: 0.15px;
  color: #898989;
}
.page-filters__right-select-wrapper {
  display: flex;
  align-items: center;
}
.date-icon {
  background-color: var(--primary-color);
  color: #fff;
  cursor: pointer;
  padding: 8px 10px;
  border-radius: 0px 8px 8px 0px;
  position: relative;
  left: -6px;
}
.datetime-input {
  border-radius: 8px !important;
}
.page-route-select {
  display: flex;
  align-items: center;
}
.page-route-select-text {
  font-weight: 400;
  font-size: 1.36em;
  line-height: 17px;
  color: #ababab;
  margin-right: 20px;
  cursor: pointer;
}
.page-route-select-icon {
  color: var(--primary-color);
  margin-right: 20px;
}
.page-title {
  font-weight: 600;
  font-size: 2.72em;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: #605f5f;
  margin-top: 35px;
}
.attendances-page__clear-filter-container {
  display: flex;
  justify-content: flex-end;
}
.attendances-page__actions-container {
  display: flex;
  margin: 1.5em 0em;
}
.excel-button {
  margin-left: auto;
}
.attendances-page__product-input-container {
  display: flex;
  align-items: center;
}
.attendances-page__product-input {
  border: 1px solid #c2c2c3;
  font-size: 17px;
  padding: 11px;
  border-radius: 5px;
  width: 30vw;
}
.attendances-page__actions-inputs {
  width: 30%;
}
.attendances-page__actions-wrapper {
  width: 40%;
}
.attendances-page__product-input:focus {
  border: 1px solid #c2c2c3 !important;
}
.register-width {
  width: 17%;
}
.last-width {
  width: 15%;
}
.search-icon {
  position: relative;
  left: -35px;
  color: #606060;
}
.select-input-width {
  margin-right: 10px;
}
.attendances-page__input-title-wrapper {
  padding-bottom: 5px;
}
.attendances-page__input-title {
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: #898989;
  font-size: 20px;
}
.attendance-page-table-container {
  margin: 2em 0em;
}
.page-table-header {
  background: #fffefc;
  border: 0.5px solid #e5e5e5;
  font-weight: 400;
  color: #605f5f;
  display: flex;
  padding: 1em 0em;
}
.report-card-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 3vh;
}
.report-card {
  text-align: center;
  display: block;
  width: 15vw;
  border-radius: 5px;
  border-width: 1px;
  border-style: solid;
  padding: 1vh 0;
  font-size: 1.5em;
  font-weight: bold;
}
.card-blue {
  background-color: rgb(208, 226, 232);
  border-color: rgb(130, 130, 249);
}
.card-green {
  background-color: rgb(200, 234, 200);
  border-color: rgb(36, 141, 36);
}
.card-yellow {
  background-color: rgb(247, 247, 234);
  border-color: rgb(249, 249, 87);
}
.page-table-header-text {
  padding-left: 10px;
  font-weight: 600;
  font-size: 1.19em;
  color: #505050;
}
.info-container {
  display: flex;
  align-items: center;
  width: 17%;
  gap: 2%;
}
.filter-button {
  width: 17%;
}
.page-table-row {
  display: flex;
  align-items: center;
  font-weight: 300;
  font-size: 1em;
  color: #605f5f;
}
.line-padding {
  padding: 1vh 0;
  border-bottom: 1px solid lightgray;
}
.products-list-btn {
  background-color: #17a2b80d;
  color: #17a2b8;
  border-radius: 8px;
  text-align: center;
  width: 70%;
  display: block;
}
.competitors-list-btn {
  background-color: #2acd721a;
  color: #30aa4c;
  border-radius: 8px;
  text-align: center;
  width: 70%;
  display: block;
}
.list-btn-size {
  display: flex;
  width: 15%;
  gap: 10%;
}
.extra-info-container {
  border-radius: 5px;
  padding: 0.5vh 1vw;
  margin-top: 1vh;
}
.edit-user-icon {
  font-size: 1.7em;
  color: #606060;
  cursor: pointer;
}
.page-table-desc-column {
  padding: 0 0.7em;
}
.page-table-line-special {
  background: #f7f7f7;
}
.actions-width {
  width: 12%;
}
.id-width {
  width: 5%;
}
.group-width {
  width: 13%;
}
.corporate-width {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 1vw;
}
.cnpj-width {
  width: 0%;
}
.phone-width {
  width: 0%;
}
.resale-width {
  width: 15%;
}
.area-width {
  width: 12%;
}
.state-width {
  width: 0%;
}
.responsible-width {
  width: 16%;
}
.status-width {
  width: 15%;
}
.answers-icon {
  font-size: 1.5em;
  color: #46ad5d;
  cursor: pointer;
  margin-right: 5px;
}
.monitor-icon {
  font-size: 1.5em;
  color: var(--primary-color);
  cursor: pointer;
  margin-right: 5px;
}
.invite-icon {
  font-size: 1.5em;
  color: var(--primary-color);
  cursor: pointer;
  margin-right: 5px;
}
.table-select-width {
  width: 15vw !important;
}
.old-show {
  background-color: rgb(248, 227, 227);
  padding-right: 1vw;
  border-radius: 8px;
}
.edit-table-icon {
  margin-right: 1.5em;
  cursor: pointer;
}
.page-selected-filters-container {
  display: flex;
  margin: 1em 0em;
}
.page-selected-filters {
  background: #fcf9f7;
  border: 1px solid #e5e5e5;
  box-sizing: border-box;
  border-radius: 8px;
  padding: 7px 12px;
  display: flex;
  align-items: center;
  margin-right: 10px;
}
.page-selected-filters-text {
  font-weight: 300;
  font-size: 14px;
  letter-spacing: 0.15px;
  color: var(--primary-color);
  margin-right: 5px;
}
.page-selected-filters-icon {
  color: var(--primary-color);
  cursor: pointer;
}

.page-table-header-mobile {
  display: none;
}
.attendances-page__infos-wrapper {
  display: flex;
  justify-content: space-between;
}
.mobile-alert-size {
  text-align: center;
}
.attendances-page__started-request {
  color: rgb(144, 135, 83);
  font-size: 1em;
  border-radius: 5px;
  font-weight: bold;
}
.attendances-page__objective-request {
  color: rgb(46, 46, 248);
  background-color: lightblue;
  border-color: rgb(46, 46, 248);
  border-style: solid;
  border-width: 0;
  font-size: 1em;
  padding: 1vh 0.5vw;
  font-weight: bold;
  border-radius: 5px;
}
.attendances-page__implanted-request {
  color: #0677c9;
  background-color: #17a2b81a;
  background-color: lightblue;
  border-color: #0677c9;
  border-style: solid;
  border-width: 0;
  font-size: 1em;
  padding: 1vh 0.5vw;
  font-weight: bold;
  border-radius: 5px;
}
.attendances-page__waiting-first-request {
  color: #de9153;
  font-size: 1em;
  font-weight: bold;
  border-radius: 5px;
}
.attendances-page__on-watch-request {
  color: #3b8c88;
  font-size: 1em;
  font-weight: bold;
}
.extra-info-table-row {
  display: flex;
}
.attendances-page__on-alert-request {
  color: #7a8370;
  font-size: 1em;
  font-weight: bold;
  border-radius: 5px;
}
.attendances-page__suspended-request {
  color: #cd2a2a;
  font-size: 1em;
  font-weight: bold;
  border-radius: 5px;
}
.attendances-finished-request {
  color: #0074b4;
  font-size: 1em;
  font-weight: bold;
  border-radius: 5px;
}
.attendances-page__total-request {
  color: rgb(197, 129, 2);
  font-size: 1.2em;
  font-weight: bold;
  border-radius: 5px;
}

.attendances-page__waiting-client-request {
  color: rgb(118, 101, 9);
  font-size: 1em;
  font-weight: bold;
  border-radius: 5px;
}
.pop-over-strong {
  color: var(--primary-color);
  font-weight: bold;
}
.total-requests-container {
  display: flex;
  justify-content: center;
  color: #878787;
  font-size: 1.2em;
}
.mobile-alert-size {
  cursor: pointer;
}
.attach-file-icon {
  font-size: 1.5em;
  color: #404040;
  cursor: pointer;
}
.expand-icon {
  font-size: 2em;
  color: #404040;
  cursor: pointer;
}
.expand-header {
  margin: 1vw 5vw;
  padding: 0.25em 0;
}
.expand-row {
  margin: 0 5vw;
}

.kanban-container {
  margin: 20px 0;
  overflow-x: auto;
  width: 100%;
}

.kanban-board {
  display: flex;
  overflow-x: auto;
  padding: 10px;
  gap: 15px;
  min-height: 600px;
  position: relative;
  cursor: grab;
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f1f1f1;

  &:active {
    cursor: grabbing;
  }
}

.kanban-board::-webkit-scrollbar {
  width: 8px;
  height: 12px;
}

.kanban-board::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 6px;
}

.kanban-board::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 6px;
  transition: background-color 0.3s ease;
}

.kanban-board::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.kanban-column {
  background: #f5f5f5;
  border-radius: 8px;
  min-width: 416px;
  max-width: 300px;
  display: flex;
  flex-direction: column;
  max-height: 110vh;
  flex-shrink: 0;
  transition: all 0.2s ease;
  padding-bottom: 10px;
}

.kanban-column-header {
  padding: 12px;
  background: #e68c50;
  border-radius: 8px 8px 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;

  h3 {
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    color: white;
  }

  .badge {
    color: white;
    border-radius: 10px;
    padding: 2px 8px;
    font-size: 12px;
  }
}

.kanban-cards-container {
  flex: 1;
  overflow-y: auto;
  padding: 10px;
  min-height: 100px;
  scrollbar-width: thin;
  scrollbar-color: #d4d4d4 #f5f5f5;
}

.kanban-cards-container::-webkit-scrollbar {
  width: 6px;
}

.kanban-cards-container::-webkit-scrollbar-track {
  background: #f5f5f5;
  border-radius: 10px;
}

.kanban-cards-container::-webkit-scrollbar-thumb {
  background: #d4d4d4;
  border-radius: 10px;
  transition: background-color 0.3s ease;
}

.kanban-cards-container::-webkit-scrollbar-thumb:hover {
  background: #b8b8b8;
}

.kanban-card {
  background: white;
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  cursor: grab;
  transition: transform 0.2s ease;
  position: relative;

  &:active {
    cursor: grabbing;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
    z-index: 999;
  }

  &:last-child {
    margin-bottom: 0;
  }
}

.kanban-card-header {
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  strong {
    flex: 1;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.kanban-card-actions {
  margin-left: auto;

  .answers-icon {
    font-size: 18px;
    color: #606060;
    cursor: pointer;

    &:hover {
      color: var(--primary-color);
    }
  }
}

.kanban-card-content {
  .kanban-card-field {
    margin-bottom: 6px;
    font-size: 12px;

    .label {
      font-weight: 600;
      color: #666;
    }
  }
}

.kanban-card-actions-full {
  display: flex;
  justify-content: space-around;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #eee;

  .kanban-action-btn {
    cursor: pointer;
    color: #606060;

    &:hover {
      color: var(--primary-color);
    }
  }
}
.kanban-board::before,
.kanban-board::after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  width: 40px;
  pointer-events: none;
  z-index: 5;
  opacity: 0;
  transition: opacity 0.3s;
}

.kanban-board::before {
  left: 0;
}

.kanban-board::after {
  right: 0;
}

.kanban-board.scrolling-left::before,
.kanban-board.scrolling-right::after {
  opacity: 1;
}

::v-deep .status-select .multiselect__tags {
  padding: 16px 25px 32px 10px !important;
}
@media only screen and (max-width: 1050px) {
  .page-container {
    font-size: 1.25vw;
  }
}
@media only screen and (max-width: 900px) {
  .status-width {
    width: 24%;
  }
}
@media only screen and (max-width: 800px) {
  .page-container {
    font-size: 1.5vw;
  }
}

@media only screen and (max-width: 768px) {
  .kanban-board {
    flex-direction: column;
  }

  .kanban-column {
    min-width: 100%;
    max-width: 100%;
  }
  .cc-popover {
    margin-bottom: 30%;
  }
}
@media only screen and (max-width: 630px) {
  .desktop {
    display: none;
  }
  .attendances-page__clear-filter-container {
    margin-top: 2vh;
  }
  .page-container {
    font-size: 2.5vw;
    margin-right: 3vw;
  }
  .page-table-header {
    display: none;
  }
  .page-table-row {
    flex-direction: column;
    font-size: 1.2em;
  }
  .actions-width {
    width: 100%;
  }
  .id-width {
    width: 100%;
  }
  .group-width {
    width: 100%;
  }
  .corporate-width {
    flex: unset;
    width: 100%;
  }
  .cnpj-width {
    width: 100%;
  }
  .phone-width {
    width: 100%;
  }
  .resale-width {
    width: 100%;
  }
  .state-width {
    width: 100%;
  }
  .responsible-width {
    width: 100%;
  }
  .status-width {
    width: 100%;
  }
  .page-table-desc-column {
    display: flex;
    justify-content: space-between;
    text-align: end;
  }
  .page-table-input-select {
    width: fit-content;
  }
  .change-status {
    width: fit-content;
  }
  .page-table-header-mobile {
    font-weight: 600;
    font-size: 1.19em;
    color: #505050;
    display: flex;
  }
  .attendances-page__actions-container {
    flex-wrap: wrap;
  }
  .attendances-page__actions-inputs {
    width: 100%;
    margin-bottom: 2vh;
  }
  .excel-button {
    margin-left: 0;
    margin-right: auto !important;
  }
  .attendances-page__actions-wrapper {
    width: 100%;
  }
  .attendances-page__infos-wrapper {
    flex-wrap: wrap;
  }
  .mobile-alert-size {
    width: 45%;
    margin-bottom: 1vh;
    text-align: center;
  }
}
@media only screen and (max-width: 700px) {
  .page-container {
    font-size: 3vw;
  }
  .report-card-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 2vh;
  }
  .report-card {
    width: 100%;
  }
  .report-card-graphic-container {
    grid-template-columns: 1fr;
  }
  .dashboard-table-container {
    width: 100%;
  }
  .attendances-page__infos-wrapper {
    grid-template-columns: 1fr;
  }
  .mobile-alert-size {
    width: 100%;
    justify-content: center !important;
  }
  .filter-button {
    width: 50%;
    margin: 0 auto;
  }
}
@media only screen and (max-width: 380px) {
  .page-container {
    font-size: 3.5vw;
  }
}
</style>
